'use client';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { LocationPermissionHelp } from './LocationPermissionHelp';

export const PinCodeInput = ({ pincode, onChange, onCheck, loading, error, onUseLocation, detectingLocation }) => (
    <div className="flex flex-column gap-1">
        <label className="text-xs font-semibold text-500 uppercase">Enter Pincode</label>
        <div className="flex gap-2">
            <InputText
                value={pincode}
                onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="6-digit pincode"
                className={`flex-1${error ? ' p-invalid' : ''}`}
                keyfilter="int"
                maxLength={6}
                onKeyDown={(e) => e.key === 'Enter' && pincode.length === 6 && onCheck()}
                inputMode="numeric"
            />
            {onUseLocation && (
                <Button
                    type="button"
                    icon={`pi ${detectingLocation ? 'pi-spin pi-spinner' : 'pi-map-marker'}`}
                    onClick={onUseLocation}
                    disabled={detectingLocation}
                    className="p-button-sm p-button-outlined"
                    style={{ flexShrink: 0 }}
                    title="Use my current location"
                    aria-label="Use my current location"
                />
            )}
            <Button
                label="Check"
                onClick={onCheck}
                loading={loading}
                disabled={pincode.length !== 6}
                className="p-button-sm"
                style={{ whiteSpace: 'nowrap' }}
            />
        </div>
        {error && (
            <div>
                <small className="p-error text-xs">{error}</small>
                {error.includes('browser settings') && <LocationPermissionHelp />}
            </div>
        )}
    </div>
);
